// extracted by mini-css-extract-plugin
export var cardContent = "AnnualMemberContainer_cardContent__cNC2u";
export var customBestCarStyles = "AnnualMemberContainer_customBestCarStyles__ximMk";
export var wrapper = "AnnualMemberContainer_wrapper__MMuAM";
export var wrapperList = "AnnualMemberContainer_wrapperList__-dp8J";